const config = {
    imagesUrl: location.host === 'russian.rt.com' ? '//russian.rt.com/olympic2018' : ''
};

export default config;



// WEBPACK FOOTER //
// ./src/config.js